import { useContext } from 'react';
import { StableNavigateContext } from './_contexts/StableNavigateContext';

/** Смотри StableNavigateContext */
export default function useStableNavigate() {
  return useContext(StableNavigateContext).current;
}
